module.exports = "/_next/static/images/SodaFoundation-ecbd499991f61ba3222a10454837b7bc.jpg";